/* PDP only (loaded by sections/related-products.liquid): the colour strip on a "You may also like" card.
   - its two arrows step to the previous / next colour (the card picture changes with it) instead of only sliding the row of tiles
   - when the card has more colours than fit between the arrows, the row is cut to the tiles that fit and slides with the arrows */
(function () {
  var TILE = 40; // a 30px tile + the 10px gap
  var MAX_VISIBLE = 7; // the Figma bar: 7 tiles = 270px
  var ARROWS = 118; // the two arrow boxes with their 13px offset
  var STRIP = '.related-products .swatch-single.swatch-view-slide';

  function tilesOf(strip) {
    return strip.querySelectorAll('li.swatch-view-item');
  }

  function visibleCount(strip) {
    var inner = strip.closest('.card__inner') || strip.closest('.grid__item');
    var width = inner ? inner.getBoundingClientRect().width : 0;
    if (!width) return MAX_VISIBLE;
    return Math.max(1, Math.min(MAX_VISIBLE, Math.floor((width - ARROWS) / TILE)));
  }

  // cuts the row to the window of tiles around the current colour and slides it; nothing changes when all the tiles fit
  function layout(strip) {
    var tiles = tilesOf(strip);
    var count = visibleCount(strip);
    var index = parseInt(strip.getAttribute('data-pdp-colour') || '0', 10);

    Array.prototype.forEach.call(strip.querySelectorAll('.swatch-navigation-wrapper'), function (arrow) {
      var isRight = arrow.getAttribute('navigation') === 'right';
      arrow.classList.toggle('star-disabled', isRight ? index >= tiles.length - 1 : index <= 0);
    });

    if (tiles.length <= count) {
      strip.removeAttribute('data-pdp-slide');
      strip.style.removeProperty('--pdp-window');
      strip.style.removeProperty('--pdp-shift');
      Array.prototype.forEach.call(tiles, function (tile) { tile.classList.remove('pdp-swatch-out'); });
      return;
    }

    var start = parseInt(strip.getAttribute('data-pdp-start') || '0', 10);
    if (index < start) start = index;
    if (index > start + count - 1) start = index - count + 1;
    start = Math.max(0, Math.min(tiles.length - count, start));
    strip.setAttribute('data-pdp-start', start);

    strip.setAttribute('data-pdp-slide', '');
    strip.style.setProperty('--pdp-window', count * TILE - 10 + 'px');
    strip.style.setProperty('--pdp-shift', -start * TILE + 'px');
    Array.prototype.forEach.call(tiles, function (tile, i) {
      tile.classList.toggle('pdp-swatch-out', i < start || i >= start + count);
    });
  }

  function layoutAll() {
    Array.prototype.forEach.call(document.querySelectorAll(STRIP), function (strip) {
      strip.setAttribute('data-pdp-init', '');
      layout(strip);
    });
  }

  // the app draws the strips after the page has loaded (and again now and then)
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      if (document.querySelector(STRIP + ':not([data-pdp-init])')) layoutAll();
    });
  }

  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', layoutAll);
  queue();

  document.addEventListener(
    'click',
    function (event) {
      var arrow = event.target.closest('.related-products .swatch-navigation');
      if (!arrow) return;

      var strip = arrow.closest('.swatch-single');
      var tiles = strip ? strip.querySelectorAll('li.swatch-view-item .swatch-selector') : [];
      if (!tiles.length) return;

      event.preventDefault();
      event.stopPropagation();

      var index = parseInt(strip.getAttribute('data-pdp-colour') || '0', 10);
      index += arrow.classList.contains('swatch-navigation-right') ? 1 : -1;
      index = Math.max(0, Math.min(tiles.length - 1, index));
      strip.setAttribute('data-pdp-colour', index);

      Array.prototype.forEach.call(tiles, function (tile, i) {
        tile.closest('li').classList.toggle('pdp-swatch-current', i === index);
      });
      layout(strip);

      // from now on the card shows the picture of the chosen colour (not the second picture it shows on a plain hover)
      var card = strip.closest('.grid__item');
      if (card) card.classList.add('pdp-colour-picked');

      // the app switches the card picture when a tile is hovered
      ['mouseover', 'mouseenter', 'pointerenter'].forEach(function (name) {
        tiles[index].dispatchEvent(new MouseEvent(name, { bubbles: true }));
      });
    },
    true
  );

  /* hovering a colour tile also switches the picture: show that picture, until the mouse leaves the card */
  document.addEventListener('mouseover', function (event) {
    var tile = event.target.closest && event.target.closest('.related-products .swatch-single li.swatch-view-item');
    var card = tile && tile.closest('.grid__item');
    if (card) card.classList.add('pdp-colour-picked');
  });

  document.addEventListener('mouseout', function (event) {
    var card = event.target.closest && event.target.closest('.related-products .grid__item');
    if (card && !card.contains(event.relatedTarget)) card.classList.remove('pdp-colour-picked');
  });
})();
